export const USER_ROLE = {
  SUPERADMIN: "SUPERADMIN",
  ADMINOFFICER: "ADMINOFFICER",
  FIELDOFFICER: "FIELDOFFICER",
};
